import Controller from "csi/action/Controller";
import PostRequest from "csi/comm/PostRequest";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";
import page from "csi/page";

const UnlinkStyleBOMController = declare(Controller, {
	/**
     * @override
     */
	preProcess() {
		this.confirmAction({});
	},

	/**
     * On confirm proceed with unlinking of ThemeBOM from StyleBOM
     * On cancel refresh the row so that the toggle is rendered correctly
     * @param {String} key - the button key hit by user
     */
	onConfirm(key: String) {
		if (key == MessageDialog.BUTTON_UNLINK) {
			this.process();
		} else {
			this.getContext().view.redrawNode(this.m_element);
			this.postProcess();
		}
	},

	/**
     * Prompt confirmation with buttons “Unlink” and “Cancel”.
     * @override
     */
	confirmAction(params: any) {
		params.title = locale.resource(this.getContext().ac.m_action.m_id);
		params.message = locale.typeAction("ApparelBOMRevision", this.getContext().ac.m_action.m_id + "_Warning");
		params.buttons = [MessageDialog.BUTTON_UNLINK, MessageDialog.BUTTON_CANCEL];

		this.inherited(arguments);
	},

	/**
     * @override
     */
	process() {
		const bomUrl = this.m_urlNode ? this.m_urlNode : this.getContext().cache.getNode(this.m_urlParent).__Parent__;
		const linkedToMaterialPlan = this.m_cache.getNode(bomUrl).LinkedToMaterialPlan;

		if (linkedToMaterialPlan){
			const postReq = new PostRequest("ProductSpec", "UnlinkFromTheme")
				.addParameter("ParentURL", this.m_cache.getNode(bomUrl).CurrentRevision);
			this.waitForPublish(postReq.post(), true);
			this.getContext().view.redrawNode(this.m_element); 
		} else {
			const postReq = new PostRequest("ProductSpec", "UnlinkStyleBOMFromThemeBOM")
				.addParameter("URL", bomUrl);
			this.waitForPublish(postReq.post(), true);
			this.getContext().view.redrawNode(this.m_element);
		}
	},
});

export = UnlinkStyleBOMController;
